import { graphqlFetch } from '@api/graphql/gql-fetch';
import {
	type ReviewsForStorefront,
	getReviewsForStorefrontQuery,
} from '@api/graphql/reviews/getReviewsForStorefront';
import type { buildVariablesForGetReviewsForStorefront } from '@api/reviews/getReviewsForStorefront/build-variables';
import { mapReviewsForStorefront } from '@api/reviews/getReviewsForStorefront/mapper';
import { getUnifiedReviewsUrl } from '@api/reviews/url';
import { Logger } from '@utils/logger/logger';

type Variables = Awaited<
	ReturnType<typeof buildVariablesForGetReviewsForStorefront>
>;

const headers = {
	'x-tenant-id': 'tk-us',
};

export const fetchReviewsForStorefront = async (
	storefrontId: string,
	variables: Variables,
	signal?: AbortSignal,
) => {
	try {
		const result = await graphqlFetch<ReviewsForStorefront>(
			{
				url: getUnifiedReviewsUrl(),
				query: getReviewsForStorefrontQuery,
				variables,
				headers: new Headers(headers),
			},
			signal,
		);

		if (result.errors?.length) {
			const errors = result.errors.map((error) => new Error(error.message));
			for (const error of errors) {
				Logger.error({
					log_message: 'GraphQL Error fetching reviews for storefront',
					errorToLog: error,
					newRelic: true,
				});
			}
			throw errors;
		}

		return mapReviewsForStorefront(
			storefrontId,
			result.data,
			variables.page,
			variables.size,
		);
	} catch (e) {
		if (!Array.isArray(e)) {
			Logger.error({
				errorToLog: e,
				newRelic: true,
				log_message: 'Error fetching reviews for storefront',
			});
		}
		throw e;
	}
};
